var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkerOval(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.026,
    height: 135.026,
    viewBox: "0 0 135.026 135.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2333",
    "data-name": "Rectangle 2333",
    width: 135.026,
    height: 135.026,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12230",
    "data-name": "Group 12230",
    opacity: 0.28,
    clipPath: "url(#clip-path)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M67.513,135.026a67.513,67.513,0,1,1,67.514-67.513,67.588,67.588,0,0,1-67.514,67.513m0-133.685a66.171,66.171,0,1,0,66.172,66.172A66.247,66.247,0,0,0,67.513,1.342",
    fill: "#004897"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M66.738,131.22a64.474,64.474,0,1,1,64.475-64.473A64.546,64.546,0,0,1,66.738,131.22m0-127.606a63.132,63.132,0,1,0,63.133,63.133A63.2,63.2,0,0,0,66.738,3.614",
    transform: "translate(0.774 0.777)",
    fill: "#004897"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M64.818,121.762a56.936,56.936,0,1,1,56.936-56.935,57,57,0,0,1-56.936,56.935m0-112.53a55.594,55.594,0,1,0,55.594,55.6,55.659,55.659,0,0,0-55.594-55.6",
    transform: "translate(2.694 2.697)",
    fill: "#004897"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M62.677,111.219A48.533,48.533,0,1,1,111.21,62.685a48.587,48.587,0,0,1-48.533,48.533m0-95.725a47.192,47.192,0,1,0,47.192,47.192A47.244,47.244,0,0,0,62.677,15.494",
    transform: "translate(4.835 4.838)",
    fill: "#004897"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M60.865,102.294a41.421,41.421,0,1,1,41.422-41.42,41.467,41.467,0,0,1-41.422,41.42m0-81.5a40.079,40.079,0,1,0,40.08,40.08,40.125,40.125,0,0,0-40.08-40.08",
    transform: "translate(6.647 6.65)",
    fill: "#004897"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M59.274,94.456A35.175,35.175,0,1,1,94.449,59.282,35.212,35.212,0,0,1,59.274,94.456m0-69.007A33.833,33.833,0,1,0,93.107,59.282,33.87,33.87,0,0,0,59.274,25.449",
    transform: "translate(8.239 8.241)",
    fill: "#004897"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M55.763,77.164A21.393,21.393,0,1,1,77.156,55.771,21.417,21.417,0,0,1,55.763,77.164m0-41.444A20.051,20.051,0,1,0,75.814,55.771,20.073,20.073,0,0,0,55.763,35.72",
    transform: "translate(11.749 11.752)",
    fill: "#004897"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M57.969,88.028A30.051,30.051,0,1,1,88.02,57.978,30.085,30.085,0,0,1,57.969,88.028m0-58.76a28.709,28.709,0,1,0,28.709,28.71,28.742,28.742,0,0,0-28.709-28.71",
    transform: "translate(9.544 9.547)",
    fill: "#004897"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M56.82,82.369A25.541,25.541,0,1,1,82.362,56.828,25.57,25.57,0,0,1,56.82,82.369m0-49.741a24.2,24.2,0,1,0,24.2,24.2,24.227,24.227,0,0,0-24.2-24.2",
    transform: "translate(10.693 10.695)",
    fill: "#004897"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M54.907,72.993A18.033,18.033,0,1,1,72.94,54.959,18.053,18.053,0,0,1,54.907,72.993m0-34.724A16.691,16.691,0,1,0,71.6,54.959a16.709,16.709,0,0,0-16.691-16.69",
    transform: "translate(12.606 12.624)",
    fill: "#004897"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M54.208,69.506A15.29,15.29,0,1,1,69.5,54.217a15.306,15.306,0,0,1-15.29,15.289m0-29.238A13.948,13.948,0,1,0,68.157,54.217,13.964,13.964,0,0,0,54.208,40.269",
    transform: "translate(13.304 13.307)",
    fill: "#004897"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M53.541,66.224A12.674,12.674,0,1,1,66.215,53.55,12.687,12.687,0,0,1,53.541,66.224m0-24.006A11.332,11.332,0,1,0,64.873,53.55,11.344,11.344,0,0,0,53.541,42.218",
    transform: "translate(13.971 13.973)",
    fill: "#004897"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M53,63.556A10.548,10.548,0,1,1,63.548,53.008,10.56,10.56,0,0,1,53,63.556M53,43.8a9.206,9.206,0,1,0,9.206,9.205A9.215,9.215,0,0,0,53,43.8",
    transform: "translate(14.513 14.515)",
    fill: "#004897"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M52.54,61.28a8.74,8.74,0,1,1,8.741-8.739A8.75,8.75,0,0,1,52.54,61.28m0-16.138a7.4,7.4,0,1,0,7.4,7.4,7.408,7.408,0,0,0-7.4-7.4",
    transform: "translate(14.973 14.973)",
    fill: "#004897"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M27.837,51.022a2.58,2.58,0,1,1-2.58-2.579,2.58,2.58,0,0,1,2.58,2.579",
    transform: "translate(7.752 16.56)",
    fill: "#00567a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkerOval);
export default __webpack_public_path__ + "static/media/darker-oval.99b2ae52b599f66c47168eabad1ec85c.svg";
export { ForwardRef as ReactComponent };